/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { ReserveSurveyMarksBody } from '../../models/reserve-survey-marks-body';
import { ReserveSurveyMarksDto } from '../../models/reserve-survey-marks-dto';

export interface ReserveSurveyMarksForUser$Params {
  body: ReserveSurveyMarksBody;
}

export function reserveSurveyMarksForUser(
  http: HttpClient,
  rootUrl: string,
  params: ReserveSurveyMarksForUser$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReserveSurveyMarksDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    reserveSurveyMarksForUser.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReserveSurveyMarksDto>;
      }),
    );
}

reserveSurveyMarksForUser.PATH = '/me/surveyMarks/reserved';
